import React from 'react';
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {FaCarAlt, FaClipboardList} from "react-icons/fa";

const TimelineTitle = ({ data, boName, boId }) => {
    const boIdValue = typeof boId === "object" ? boId?.id : boId;
    const navigate = navigateHook();

    const hasDispatch = data?.[0].dispatch_link;
    const hasEncounter = data?.[0].encounter_relation;
    const hasBothLinks = hasDispatch && hasEncounter;

    return (
        <div className="mb-6 text-[15px] font-semibold text-zinc-700 flex flex-col gap-2 w-full">
            <section className={'flex flex-row gap-2 justify-center align-center'}>
                <span className={'text-[24px]!'}>{boName} <a onClick={() => navigate(`/bo/redirect/${boId.replace('/', '-')}`, true)} className="inner-link" title={`Acessar ${boName} ${boId}`}>{boIdValue ?? ""}</a></span>
            </section>

            <section className={`${hasBothLinks ? "grid grid-cols-[1fr_auto_1fr] transform translate-x-2.25" : "flex justify-center"} items-center w-full text-[13px] gap-2`}>
                <span className={`${hasBothLinks ? "text-right justify-end" : "text-center"} flex flex-row gap-2 items-center`}>
                    { hasDispatch && (<>Despacho - <a onClick={() => navigate(`/despacho/dispatch/form/${data?.[0].dispatch_link}`, true)} className="inner-link" title="Acessar despacho">{data?.[0].dispatch_relation ?? "Sem talão"}</a></>)}
                </span>

                { hasBothLinks && (
                    <span className="text-center">|</span>
                )}

                <span className={`${hasBothLinks ? "text-left justify-start" : "text-center"} flex flex-row gap-2 items-center`}>
                    { hasEncounter && (<>Abordagem - <a onClick={() => navigate(`/encounter/form/${data?.[0].encounter_relation}`, true)} className="inner-link" title="Acessar abordagem">{data?.[0].encounter_relation ?? ""}</a></>)}
                </span>
            </section>

        </div>
    );
};

export default TimelineTitle;